<script>
  import HeaderAndLogo from "@shared/svelte/Components/Storefront/HeaderAndLogo.svelte";
  import FeaturedProduct from "@shared/svelte/Components/Storefront/FeaturedProduct.svelte";
  import FeaturedItems from "@shared/svelte/Components/Storefront/FeaturedItems.svelte";
  import Collections from "@shared/svelte/Components/Storefront/Collections.svelte";
  import ProductCatalog from "@shared/svelte/Components/Storefront/ProductCatalog.svelte";
  import Footer from "@shared/svelte/Components/Storefront/Footer.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import UIRouterLink from "../UIRouterLink.svelte";
  import SalesforceChat from "@shared/services/salesforce_chat";

  export let storefront;
  export let callbacks;

  if (window["C"].APP_NAME == "distributor") {
    setTimeout(function () {
      SalesforceChat.hide();
    }, 1000);
  }
</script>

<style>
  #grid-column-inherit {
    grid-column: inherit;
  }
</style>

<FizzStyles>
  <main data-grid-area="main">
    <section class="fizz-layout-storefront-preview" style="background: #FFF;">
      <HeaderAndLogo {storefront} />
      <div data-grid-area="main">
        {#if storefront?.distributor?.ordering_disabled}
          <div class="fizz-alert-warning fizz-alert--small fizz-stack-12">
            Provi is temporarily not accepting orders for {storefront.distributor.name}, but you can
            still add items to your cart to order later. Contact your rep for more information.
          </div>
        {/if}
        <FeaturedProduct {storefront} maxHeight={"375px"} />
        <FeaturedItems {storefront} />
        <div data-grid-area="product-cards" class="fizz-stack-24">
          <Collections {storefront} />
          <ProductCatalog {storefront} {callbacks} />
        </div>
        <div class="fizz-surface-blue fizz-inset-square-32 fizz-stack-24" id="grid-column-inherit">
          <h3
            class="fizz-heading-3 fizz-flex-row fizz-justify-center fizz-stack-24 fizz-text-center"
          >
            Search all products from {storefront.distributor.name}
          </h3>
          <p class="fizz-flex-row fizz-justify-center">
            <UIRouterLink
              stateName="layout.product_listing"
              params={{ distributors: storefront.distributor_id }}
              button={true}
            >
              <button class="fizz-button fizz-button-small">View entire catalog</button>
            </UIRouterLink>
          </p>
        </div>
        <Footer {storefront} />
      </div>
    </section>
  </main>
</FizzStyles>
